import { render } from "./KebabMenu.vue?vue&type=template&id=56d3dec2"
import script from "./KebabMenu.vue?vue&type=script&lang=js"
export * from "./KebabMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__